import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import styles from './HitTheTrail.module.scss';

const HitTheTrailShimmerCard = () => {
  return (
    <ShimmerContainer>
      <div className={styles.cardWrapper}>
        <div className={styles.card} />
      </div>
    </ShimmerContainer>
  );
};

export default HitTheTrailShimmerCard;
